import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import type { WebbillSyncConfigRequest } from '@/api/endpoints/webbill-sync'
import { webbillSyncApi } from '@/api/endpoints/webbill-sync'

export function useWebbillSyncConfig() {
  return useQuery({
    queryKey: ['webbill-sync', 'config'],
    queryFn: webbillSyncApi.getConfig,
    staleTime: 1000 * 60 * 5,
  })
}

export function useSaveWebbillSyncConfig() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (data: WebbillSyncConfigRequest) =>
      webbillSyncApi.saveConfig(data),
    onSuccess: () =>
      qc.invalidateQueries({ queryKey: ['webbill-sync', 'config'] }),
  })
}

export function useWebbillSyncHistory() {
  return useQuery({
    queryKey: ['webbill-sync', 'history'],
    queryFn: () => webbillSyncApi.getHistory(),
    staleTime: 1000 * 30,
  })
}

export function useTriggerWebbillSync() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: webbillSyncApi.triggerSync,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['webbill-sync', 'history'] })
      qc.invalidateQueries({ queryKey: ['webbill-sync', 'config'] })
    },
  })
}
